import { render, staticRenderFns } from "./AddEditSale.vue?vue&type=template&id=67185ce3&scoped=true&"
import script from "./AddEditSale.vue?vue&type=script&lang=js&"
export * from "./AddEditSale.vue?vue&type=script&lang=js&"
import style0 from "./AddEditSale.vue?vue&type=style&index=0&id=67185ce3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67185ce3",
  null
  
)

export default component.exports